import { FormControl } from "@angular/forms";
import { TUI_FIRST_DAY, TUI_LAST_DAY, TuiDay } from "@taiga-ui/cdk";

export const DEFAULT_VALUES = {
  disabled: false,
  disableItems: () => !1,
  formControlName: "form_calendar_name",
  id: "calendar",
  isShowAdjacentValues: true,
  min: TUI_FIRST_DAY,
  max: TUI_LAST_DAY,
  value: null
};

export const VALIDATE_KEY_VALUES = {
  disabled: true,
  disableItems: true,
  formControlName: true,
  id: true,
  isShowAdjacentValues: true,
  min: true,
  max: true
};
